module.exports = __webpack_public_path__ + "c037dbbc0e6790f30e824a50010df5fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/_libs/ionic/fonts/ionicons.svg?v=2.0.1
// module id = 1480
// module chunks = 0